export default function logout() {
    if (localStorage.getItem('Token')) {

        localStorage.clear()
        // localStorage.removeItem('Token');
        // localStorage.removeItem('checkoftxt');
    }
    setTimeout(() => {
        window.location.href = '/login'
    }, 100);
}
